// extracted by mini-css-extract-plugin
module.exports = {"navDropdownWrapper":"Aa","navDropdownSide":"Ab","navDropdownLink":"Ac"};